import React from "react";
import SupportLayout from "./SupportLayout";
import AdminBusinessesContent from "../admin/components/AdminBusinessesContent";

const SupportBusinessesPage = () => {
  return (
    <SupportLayout>
      <AdminBusinessesContent useOwnLayout={true} userRole="SO" />
    </SupportLayout>
  );
};

export default SupportBusinessesPage;
